import { render, staticRenderFns } from "./offside.vue?vue&type=template&id=3a262b5d&scoped=true"
import script from "./offside.vue?vue&type=script&lang=js"
export * from "./offside.vue?vue&type=script&lang=js"
import style0 from "./offside.vue?vue&type=style&index=0&id=3a262b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a262b5d",
  null
  
)

export default component.exports